import { ReactImage } from "@tm/interfaces";
import { generateSourceSetImageUrl } from "../../utils/index";
export const ImageComponent = ({
  src,
  width,
  height,
  alt = "",
  loading = "lazy",
  className = "",
  id = "",
  cdnUrlWidths = [],
  sizes = "",
  margin,
  onMouseEnter,
  onMouseLeave,
}: ReactImage) => {
  const imgStyle = margin ? { margin } : {};
  if (!src || !width || !height) {
    return null;
  }
  if (src.endsWith && src.endsWith(".svg")) {
    return (
      <img
        src={src}
        loading={loading}
        alt={alt}
        style={imgStyle}
        className={className}
        id={id}
        width={width}
        height={height}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }
  const srcsetUrl = generateSourceSetImageUrl(
    cdnUrlWidths,
    src,
    parseInt(width)
  );
  return (
    <picture>
      <source
        data-testid="testID"
        srcSet={srcsetUrl}
        sizes={sizes ? sizes : width}
      />
      <img
        src={src}
        loading={loading}
        alt={alt}
        className={className}
        id={id}
        width={width}
        height={height}
        style={imgStyle}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </picture>
  );
};
